import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from '../../../assets/js/vfs_fonts.js';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export class MessengerPDF {
    async collectPdfData(){
        let data = await this.getMessages();
        let m = this.convertMessagesToPdfStack(data.messages);
        let document = {
            content: m,
            images: data.images,
            pageMargins: [60,50,60,50],
            defaultStyle:{
                fontSize:10
            }
        }
        console.log(JSON.parse(JSON.stringify(document)))
        let g = await pdfMake.createPdf(document);
        return g
    }
    async getMessages(){
        let a:HTMLElement[] = [];
        let messages = document.getElementById('CaseMessageHolder');
        let imgs = messages.getElementsByClassName('thumbnail');
        let images = await this.extractImages(imgs);
        let m = messages.children;
        for(var i = 0; i < m.length;i++){
            let el = m[i] as HTMLElement;
            a.push(el)
        }
        return { messages:a, images:images }
    }

    convertMessagesToPdfStack(messages:HTMLElement[]){
        let stack = [];
        for(let x of messages){
            stack.push(this.extractMessageData(x));
            stack.push(
                {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*60, y2: 5, lineWidth: 1 }], margin:[0,10,0,10]}
            )
        }
        return {stack:stack, margin:[0,0,0,15], }
    }

    extractMessageData(el:HTMLElement){
        // if el has 3 children, it was sent with images
        // a check is needed to see if images are visable
        let chunkSize = 5;
        let messageHeader = this.getMessageHeader(el.children[0] as HTMLElement);
        let messageBody = this.getInnerText(el.children[1] as HTMLElement);
        let messageImages = !!el.children[2] ? this.getImagesArray(el.children[2] as HTMLElement) : null;
        if(!!messageImages && messageImages.length > 0){
            return {
                stack:[
                    messageHeader,
                    messageBody,
                    {
                       table:{
                           body : this.chunkArray(messageImages,chunkSize),
                           widths: new Array(chunkSize).fill('*')
                       } ,
                       layout : 'noBorders',
                    }
                ],
                margin:[0,0,0,20]
            }
        }
        else{
            return {
                stack:[
                    messageHeader,
                    messageBody
                ],
                margin:[0,0,0,10],
                unbreakable:true
            }
        }
    }

    chunkArray(array,size){
        let result = []
        for (let i = 0; i < array.length; i += size) {
          let chunk = array.slice(i, i + size);
          if(chunk.length == size){ result.push(chunk) }
          else { 
              chunk = chunk.concat(new Array(size).fill('').slice(chunk.length));
              result.push(chunk)
            }
        }
        return result
    }

    getMessageHeader(el:HTMLElement){
        let f = el.firstChild as HTMLElement;
        let l = el.lastChild as HTMLElement;
        return {
            columns:[
            {text: f.innerText, bold:true},
            {text: l.innerText, alignment:'right'}
            ], margin:[0,0,0,5]
        }
    }

    getImagesArray(el:HTMLElement){
        let images = [];
        let files = el.getElementsByClassName('file');
        for(var i = 0; i < files.length; i++){
            let current = files[i] as HTMLElement;
            let img = files[i].getElementsByClassName('thumbnail')[0].id;
            let text = current.innerText;
            images.push(
                {
                    stack:[
                        {image:img, fit:[75,75]},
                        // {text: text.length > 10 ? text.slice(0,9) : text}
                    ],
                    margin:[0,20,0,20]
                }
            )
        }
        return images
    }

    getInnerText(el:HTMLElement){
        return {text:el.innerText}
    }

    async extractImages(images:HTMLCollection){
        let output = {};
        for(var i = 0; i< images.length;i++) {
            let current = images[i] as HTMLImageElement;
            output[current.id] = current.src;
        }
        return output
    }
}